module.exports = __webpack_public_path__ + "c1ca1acf4d634267ffcfa57a552c2655.svg";